import { useMemo, useCallback } from 'react';
import getValidateFn from 'js/utils/Validation';
import { useTranslations } from 'js/hooks/i18n';

import * as helpers from '../helpers';

export const useValidateWrapped = ({ validate, validationConfig, skipValidationFields }) => {
    const t = useTranslations();
    const wrappedValidate = useCallback((values) => {
        return helpers.getValidationConfig(validate(values), skipValidationFields);
    }, [validate, skipValidationFields]);

    return useMemo(() => {
        if (!validate && validationConfig) {
            return getValidateFn({
                t,
                validationConfig: helpers.getValidationConfig(validationConfig, skipValidationFields)
            });
        }

        return skipValidationFields
            ? wrappedValidate
            : validate;
    }, [t, validate, wrappedValidate, validationConfig, skipValidationFields]);
};
